import { VuexModule, Module, Action, getModule } from "vuex-module-decorators";
import store from "@/store";
import { container } from "tsyringe";
import { DispatchPresenter } from "../presenters/DispatchPresenter";
import { DispatchComponent } from "@/app/infrastructures/dependencies/modules/DispatchComponent";
import { DispatchListRequest } from "@/domain/entities/Dispatch";
import { ProcessUpdateDispatchRequest, UpdateDispatchRequest } from "@/data/payload/api/DispatchApiRequest";
import { ApiRequestList } from "@/domain/entities/MainApp";
import { ResponsePayloadV2 } from "@/domain/entities/ResponsePayload";
import { CourierShuttleListRequest, CourierShuttleListResponse } from "@/domain/entities/CourierShuttle";
import { CourierManagementPresenter } from "../presenters/CourierManagementPresenter";

DispatchComponent.init();

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "dispatch"
})
class DispatchStore extends VuexModule {
  @Action
  async getList(params: DispatchListRequest) {
    const presenter = container.resolve(DispatchPresenter);
    return presenter.getList(params);
  }

  @Action
  async getDetail(id: number) {
    const presenter = container.resolve(DispatchPresenter);
    return presenter.getDetail(id);
  }

  @Action
  async updateDispatch(payload: UpdateDispatchRequest) {
    const presenter = container.resolve(DispatchPresenter);
    return presenter.updateDispatch(payload);
  }

  @Action
  async getListTemporary(params: ApiRequestList): Promise<ResponsePayloadV2> {
    const presenter = container.resolve(DispatchPresenter);
    return presenter.getListTemporary(params);
  }

  @Action
  async processUpdateDispatch(payload: ProcessUpdateDispatchRequest): Promise<ResponsePayloadV2> {
    const presenter = container.resolve(DispatchPresenter);
    return presenter.processUpdateDispatch(payload);
  }

  @Action
  async getCourierShuttleList(params: CourierShuttleListRequest): Promise<CourierShuttleListResponse> {
    const presenter = container.resolve(CourierManagementPresenter);
    return presenter.getCourierShuttleList(params);
  }
}

export const DispatchController = getModule(DispatchStore);
